import 'regenerator-runtime/runtime';
import { SagaIterator } from 'redux-saga';
import { put, select, takeEvery } from 'redux-saga/effects';
import { GlobalActions } from '@ps20-frontend/shop-integration-redux';
import { App, isTiergruppeActive } from '@ps20-frontend/frontend-models';
import { PS20Logger } from '@ps20-frontend/logging';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { IAppState } from '../appState';
import { listedChildKeys } from '../models/childKeys';
import { TgvActions } from '../tgvActions';
import { findStoreState, sharedDispatcher } from './sharedDispatcher';

interface DashboardRow {
  appId: string;
  angebotsId?: string;
  ownerAppId?: string;
}

const ownedRowsOfDashboard = (): DashboardRow[] | undefined => {
  const warenkorb = findStoreState(App.SHOP_DASHBOARD)?.['warenkorb'];
  return Array.isArray(warenkorb) ? (warenkorb as DashboardRow[]) : undefined;
};

export function* watchChildLinkHeal(): SagaIterator {
  yield takeEvery(GlobalActions.SAVED_STATES_LOADED, safeSaga(childLinkHealSaga, App.TGV));
}

export function* childLinkHealSaga(): SagaIterator {
  const { tiergruppe, transientState }: IAppState = yield select();
  if (!isTiergruppeActive(transientState.featureToggles)) {
    return;
  }
  const rows = ownedRowsOfDashboard();
  if (rows === undefined) {
    return;
  }
  const isOwnedRow = (appId: App, angebotsId?: string): boolean =>
    rows.some(
      row =>
        row.appId === appId &&
        row.ownerAppId === App.TGV &&
        (angebotsId === undefined || row.angebotsId === angebotsId),
    );
  const deadKeys = listedChildKeys(tiergruppe).filter(key =>
    key === App.THH_HUND || key === App.THH_PFERD
      ? !isOwnedRow(key)
      : sharedDispatcher().findStoreRef(App.TKV_V2, key) === undefined ||
        !isOwnedRow(App.TKV_V2, key),
  );
  if (deadKeys.length === 0) {
    return;
  }
  PS20Logger.info(
    'TGV_CHILD_LINKS_HEALED',
    `Dropped child links without an owned Warenkorb row or registered store: ${deadKeys.join(', ')}`,
    App.TGV,
  );
  yield put(new TgvActions().childLinksHealed(deadKeys));
}
